"use strict";

const createProfileStructuredData = ({ canonicalUrl, page, site }) => {
  const artist = site.artist;
  const portrait = site.portrait;
  const website = site.website;
  const isProfilePage = canonicalUrl === artist.url;
  const isHomePage = canonicalUrl === `${site.origin}/`;
  const imageObject = {
    "@type": "ImageObject",
    "@id": portrait.id,
    url: portrait.jpegUrl,
    contentUrl: portrait.jpegUrl,
    encodingFormat: "image/jpeg",
    width: portrait.width,
    height: portrait.height,
    caption: portrait.alt,
    representativeOfPage: true,
  };
  const webPage = {
    "@type": isProfilePage ? "ProfilePage" : "WebPage",
    "@id": `${canonicalUrl}#webpage`,
    url: canonicalUrl,
    name: page.title,
    description: page.description,
    inLanguage: "ja-JP",
    isPartOf: { "@id": website.id },
    about: { "@id": artist.id },
    mainEntity: { "@id": artist.id },
    primaryImageOfPage: { "@id": portrait.id },
  };

  if (isProfilePage && page.dateModified) {
    webPage.dateModified = page.dateModified;
  }

  if (isProfilePage && page.dateCreated) {
    webPage.dateCreated = page.dateCreated;
  }

  const graph = [
    imageObject,
    {
      "@type": "Person",
      "@id": artist.id,
      name: artist.name,
      alternateName: artist.alternateName,
      jobTitle: artist.jobTitle,
      description: artist.description,
      url: artist.url,
      image: isProfilePage
        ? portrait.structuredDataImages.map((image) => image.url)
        : { "@id": portrait.id },
      sameAs: artist.sameAs,
      mainEntityOfPage: { "@id": `${artist.url}#webpage` },
    },
  ];

  if (isHomePage) {
    graph.push({
      "@type": "WebSite",
      "@id": website.id,
      url: `${site.origin}/`,
      name: website.name,
      alternateName: website.alternateName,
      inLanguage: "ja-JP",
      publisher: { "@id": artist.id },
    });
  }

  graph.push(webPage);

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
};

const serializeProfileStructuredData = (structuredData) =>
  JSON.stringify(structuredData).replace(/</g, "\\u003c");

module.exports = {
  createProfileStructuredData,
  serializeProfileStructuredData,
};
